// extracted by mini-css-extract-plugin
module.exports = {"textIntro__body":"_aA","textIntro":"_aB","textIntro__pageLink":"_aC"};